import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

class PenalidadesDadosGeraisApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async buscarItensPenalidade({ idEntidade, paginacao, idOrgao, idPenalidade, idPessoa }) {
		const url = new SearchUrlParamBuilder({
			urlPath: this.urlBuilder.itens.getUrlBuscarItensPenalidade(idEntidade),
			filters: { idOrgao, idPessoa, idPenalidade },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}
	async adicionarItensPenalidade(obj) {
		return await axios.post(this.urlBuilder.itens.getUrlAdicionarItensPenalidade(), obj)
	}
}

export default PenalidadesDadosGeraisApiClient
